import { Component, OnInit, Inject } from "@angular/core";
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/legacy-dialog";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { TransferOwnershipDataService } from "src/app/share/data-service/transfer-ownership.data.service";
import { AlertService } from "src/app/share/service/alert.service";
import { ThankyouPurchaseDialogComponent } from "../thankyou-purchase-dialog/thankyou-purchase-dialog.component";
import { PromoCodeInterface, GeneraliGetOrderInfoInterface, ChubbGenQuotationInfoInterface } from "src/app/share/interface/motor.interface";
import { MotorDataDataService } from "src/app/share/data-service/motor.data.service";
import { CommonFunction } from "src/app/share/function/common.function";

@Component({
	selector: "app-agent-code-dialog",
	templateUrl: "./agent-code-dialog.component.html",
	styleUrls: ["./agent-code-dialog.component.css"],
})
export class AgentCodeDialogComponent {
	id: string;

	quotationId: string;
	selectedAddOn: any;
	addOnValue: any;
	infoValue: any;
	mykadOrPassport: any;
	letterOfUndertaking: any;
	vehiclePhoto: any;
	fgapAddOnsIndex: string;
	ewpAmount: any;
	ewpFiles: any;
	includeRoadTax: any;

	agentCode: string;
	promoCodeId: string;

	isGeneraliIQ: boolean;
	isChubbIQ: boolean;

	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: any,
		private transferOwnershipDataService: TransferOwnershipDataService,
		private ngxSpinnerService: NgxSpinnerService,
		private alertService: AlertService,
		private dialog: MatDialog,
		public dialogRef: MatDialogRef<AgentCodeDialogComponent>,
		private motorDataDataService: MotorDataDataService
	) {
		this.quotationId = data.quotationId;
		this.selectedAddOn = data.selectedAddOn;
		this.addOnValue = data.addOnValue;
		this.infoValue = data.infoValue;
		this.mykadOrPassport = data.mykadOrPassport;
		this.letterOfUndertaking = data.letterOfUndertaking;
		this.vehiclePhoto = data.vehiclePhoto;
		this.fgapAddOnsIndex = data.fgapAddOnsIndex;
		this.ewpAmount = data.ewpAmount;
		this.ewpFiles = data.ewpFiles;
		this.includeRoadTax = data.includeRoadTax ? true : false;

		this.id = data.id;
		this.promoCodeId = data.promoCodeId;

		this.isGeneraliIQ = data.isGeneraliIQ;
		this.isChubbIQ = data.isChubbIQ;
	}

	submitAgentCode() {
		this.ngxSpinnerService.show();
		let fd = new FormData();

		fd.append("QuotationId", this.quotationId);
		if (
			this.selectedAddOn.find((e) => e.category == "Windshield") &&
			this.addOnValue.windshield
		) {
			fd.append("WindShield", this.addOnValue.windshield);
		}
		if (
			this.selectedAddOn.find((e) => e.category == "FGAP") &&
			this.fgapAddOnsIndex
		) {
			fd.append("Fgap.Value", this.fgapAddOnsIndex);
		}
		if (
			this.selectedAddOn.find((e) => e.category == "FGAP") &&
			this.addOnValue.fgap
		) {
			fd.append("Fgap.Amount", this.addOnValue.fgap);
		}
		if (this.selectedAddOn.find((e) => e.category == "EWP") && this.ewpAmount) {
			fd.append("Ewp.Value", this.addOnValue.ewp);
			fd.append("Ewp.Amount", this.ewpAmount);
		}
		if (this.ewpFiles.mileageImage.length) {
			fd.append(`Ewp.FileList[1].type`, "Mileage");
			fd.append(`Ewp.FileList[1].files`, this.ewpFiles.mileageImage[0]);
		}
		if (this.ewpFiles.vehRegCard.length) {
			fd.append(`Ewp.FileList[2].type`, "VehicleGrant");
			fd.append(`Ewp.FileList[2].files`, this.ewpFiles.vehRegCard[0]);
		}
		if (this.ewpFiles.vehInsReport.length) {
			fd.append(`Ewp.FileList[0].type`, "VehicleInspectionReport");
			fd.append(`Ewp.FileList[0].files`, this.ewpFiles.vehInsReport[0]);
		}

		if (this.infoValue.occupation) {
			fd.append("Occupation", this.infoValue.occupation);
		}

		fd.append("Address", this.infoValue.address);
		fd.append("Address2", this.infoValue.address2);
		fd.append("City", this.infoValue.city);
		fd.append("State", this.infoValue.state);
		fd.append("DeliveryAddress", this.infoValue.deliveryAddress);
		fd.append("DeliveryAddress2", this.infoValue.deliveryAddress2);
		fd.append("DeliveryCity", this.infoValue.deliveryCity);
		fd.append("DeliveryPostcode", this.infoValue.deliveryPostcode);
		fd.append("DeliveryState", this.infoValue.deliveryState);
		fd.append("IncludeRoadTax", this.addOnValue.isIncludeRoadtax ?? false);
		fd.append("Name", this.infoValue.name);
		fd.append("Email", this.infoValue.email);
		fd.append("MobileNo", this.infoValue.mobileNo);
		fd.append("FinanceType", this.infoValue.financingType);
		fd.append("Role", this.infoValue.dealerCase ? "Dealer" : "Internal");
		fd.append("AgentCode", this.agentCode);
		fd.append("Insurer", this.data.insurer);
		
		if (this.addOnValue.lltpSeats) {
			fd.append("Seat", this.addOnValue.lltpSeats);
		}			

		if (this.promoCodeId != null && typeof (this.promoCodeId != undefined)) {
			fd.append("PromoCodeId", this.promoCodeId);
		}

		if (this.infoValue.dealerCase) {
			fd.append(
				"DealerOutlet",
				this.infoValue.dealerOutlets !== "Others"
					? this.infoValue.dealerOutlets
					: this.infoValue.customDealerOutlet,
			);
		}
		if (this.infoValue.bank) {
			fd.append("HirePurchase", this.infoValue.bank);
		}
		if (this.infoValue.effectiveDate) {
			fd.append(
				"HirePurchaseEffectiveDate",
				this.infoValue.effectiveDate.toISOString(),
			);
		}

		if (
			this.selectedAddOn.find((e) => e.code == "AdditionalDrivers") &&
			this.addOnValue.drivers
		) {
			this.addOnValue.drivers.map((x, i) => {
				fd.append(`AdditionalDriverList[${i}].Dob`, CommonFunction.toCalendarDateUtc(x.dob) ?? "");
				fd.append(`AdditionalDriverList[${i}].Gender`, x.gender);
				fd.append(`AdditionalDriverList[${i}].IdType`, x.idType);
				fd.append(`AdditionalDriverList[${i}].IdentityNo`, x.identityNo);
				fd.append(`AdditionalDriverList[${i}].MaritalStatus`, x.maritalStatus);
				fd.append(`AdditionalDriverList[${i}].Name`, x.name);
				fd.append(`AdditionalDriverList[${i}].Relationship`, x.relationship);
				fd.append(`AdditionalDriverList[${i}].IsMalaysian`, x.isMalaysian);
			});
		}

		let addOnIdIndex = 0;
		if (this.selectedAddOn.length) {
			this.selectedAddOn.map((x) => {
				fd.append(`AddOnIds[${addOnIdIndex++}]`, x.id);
			});
		}

		// Care+ is an ordinary product add-on row (category PSCAREPLUS) that is held
		// outside selectedAddOn because it has its own card, so it has to be added
		// to AddOnIds by hand or the backend never sees it. Indexes continue the
		// sequence above - the model binder needs them contiguous from 0.
		if (this.data.isPsCarePlusChecked && this.data.selectedPsCarePlusId) {
			fd.append(`AddOnIds[${addOnIdIndex++}]`, this.data.selectedPsCarePlusId);
		}

		if (this.mykadOrPassport.length) {
			fd.append("FileList[0].type", "ID");
			this.mykadOrPassport.forEach((x) => {
				fd.append(`FileList[0].files`, x);
			});
		}

		if (this.letterOfUndertaking.length) {
			fd.append("FileList[1].type", "LOU");
			this.letterOfUndertaking.forEach((x) => {
				fd.append(`FileList[1].files`, x);
			});
		}

		if (this.vehiclePhoto.length) {
			fd.append("FileList[2].type", "VehiclePhoto");
			this.vehiclePhoto.forEach((x) => {
				fd.append(`FileList[2].files`, x);
			});
		}

		if (
			this.selectedAddOn.find((e) => e.category == "CART") &&
			this.addOnValue.cartDays && this.addOnValue.cartDailyCoverage
		) {
			fd.append("cartDays", this.addOnValue.cartDays);
			fd.append("cartDailyCoverage", this.addOnValue.cartDailyCoverage);
		}

		if (
			this.selectedAddOn.find((e) => e.category == "GCKT") &&
			this.addOnValue.gckt
		) {
			fd.append("gckt", this.addOnValue.gckt);
		}

		if (
			this.selectedAddOn.find((e) => e.category == "VA") &&
			this.addOnValue.va
		) {
			fd.append("va", this.addOnValue.va);
		}

		if (this.data.isCarPlusChecked) {
			fd.append("selectedInsurerCarPlus.addOnId", this.data.selectedCarPlusId);
			fd.append("selectedInsurerCarPlus.planPremium", this.data.selectedPlanPremium);
		}

		if (this.isGeneraliIQ) {
			const getOrderInfo: GeneraliGetOrderInfoInterface = {
				address1: this.infoValue.address,
				address2: this.infoValue.address2,
				city: this.infoValue.city
			};

			this.motorDataDataService.processGeneraliOrder(this.quotationId, getOrderInfo).subscribe({
				next: (x: any) => {
					this.ngxSpinnerService.hide();

					if (x.getOrderResult) {
						this.submitOrder(fd);
					}
					else {
						this.alertService.openSnackBar("Failed to process order, please contact Policy Street.");
					}
				},
				error: () => {
					this.alertService.openSnackBar("Failed to process order, please contact Policy Street.");
				}
			})
		}
		else if (this.isChubbIQ) {
			const genQuotationInfo: ChubbGenQuotationInfoInterface = {
				mobileNo: this.infoValue.mobileNo,
				address1: this.infoValue.address,
				address2: this.infoValue.address2,
				city: this.infoValue.city,
				state: this.infoValue.state,
				isHirePurchase: this.infoValue.financingType == "BankLoan",
				loanCompany: this.infoValue.bank,
				effectiveDate: this.infoValue.effectiveDate?.toISOString() ?? null
			}

			this.motorDataDataService.processChubbOrder(this.quotationId, genQuotationInfo).subscribe({
				next: (x: any) => {
					if (x.genQuotationResult) {
						this.submitOrder(fd);
					}
					else {
						this.ngxSpinnerService.hide();
						
						if (x.genQuotationMessage.includes('Error: ')) {
							this.alertService.openSnackBar("Failed to process order, please contact Policy Street.");
						}
						else {
							this.alertService.openSnackBar(x.genQuotationMessage);
						}
					}
				},
				error: () => {
					this.alertService.openSnackBar("Failed to process order, please contact Policy Street.");
				}
			})
		}
		else {
			this.submitOrder(fd);
		}
	}

	submitOrder(fd: FormData) {
		this.transferOwnershipDataService.submitOrder(this.id, fd).subscribe({
			next: (x) => {
				this.ngxSpinnerService.hide();
				let thankyouDialogRef = this.dialog.open(
					ThankyouPurchaseDialogComponent,
					{
						panelClass: "thankyou-purchase-dialog",
						data: {},
					},
				);

				thankyouDialogRef.afterClosed().subscribe((x) => {
					this.dialogRef.close(true);
				});
			},
			error: (err) => {
				this.ngxSpinnerService.hide();
				this.alertService.openSnackBar(`Error Submitting: ${err.error}`);
			},
		});
	}
}
